(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraisalFirmDialogController', AppraisalFirmDialogController);

    AppraisalFirmDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', '$window', '$translate', 'entity', 'AppraisalFirm', 'AppraisalFirmRegion', 'AppraisalFirmLocation', 'AppraiserUser', 'DataUtils'];

    function AppraisalFirmDialogController ($timeout, $scope, $state, $stateParams, $window, $translate, entity, AppraisalFirm, AppraisalFirmRegion, AppraisalFirmLocation, AppraiserUser, DataUtils) {
        var vm = this;

        vm.appraisalFirm = entity;
        vm.isNew = entity.id == null
        vm.save = save;
        vm.appraisalfirmregions = AppraisalFirmRegion.query();
        vm.appraisalfirmlocations = AppraisalFirmLocation.query();
        vm.firmAppraisers = AppraiserUser.getAvailableAssistants({appraisalFirmId: entity.id});

        // Firm proof-of-insurance documents (immediate add/remove via dedicated endpoints; the Save button does not touch them).
        if (!vm.appraisalFirm.proofOfInsurance) {
            vm.appraisalFirm.proofOfInsurance = [];
        }
        vm.newProofOfInsuranceFiles = [];
        vm.proofOfInsuranceError = null;
        vm.proofOfInsuranceUploading = false;
        vm.removeProofOfInsurance = removeProofOfInsurance;
        vm.proofOfInsuranceUrl = proofOfInsuranceUrl;

        $scope.$watch('vm.newProofOfInsuranceFiles.length', function() {
            onProofOfInsurancePicked();
        });

        function proofOfInsuranceUrl(doc) {
            // Raw download URL (works for non-admin firm users); the file-detail route is ADMIN-only.
            return 'api/files/' + doc.id + '/download/' + encodeURIComponent(doc.fileName);
        }

        function onProofOfInsurancePicked() {
            if (!vm.newProofOfInsuranceFiles || !vm.newProofOfInsuranceFiles.length) {
                return;
            }
            if (!vm.appraisalFirm.id) {
                return;
            }
            var firmId = vm.appraisalFirm.id;
            var picked = vm.newProofOfInsuranceFiles.slice();
            vm.newProofOfInsuranceFiles = [];
            vm.proofOfInsuranceError = null;

            picked.forEach(function(item) {
                var file = item.lfFile;
                if (file.type !== 'application/pdf' && !/\.pdf$/i.test(file.name)) {
                    vm.proofOfInsuranceError = 'NOT_PDF';
                    return;
                }
                vm.proofOfInsuranceUploading = true;
                DataUtils.toBase64(file, function(base64Data) {
                    $scope.$apply(function() {
                        AppraisalFirm.uploadProofOfInsurance({ id: firmId }, {
                            contentType: file.type,
                            fileName: file.name,
                            fileData: base64Data
                        }, function(saved) {
                            vm.proofOfInsuranceUploading = false;
                            vm.appraisalFirm.proofOfInsurance.push(saved);
                        }, function() {
                            vm.proofOfInsuranceUploading = false;
                            vm.proofOfInsuranceError = 'UPLOAD_FAILED';
                        });
                    });
                });
            });
        }

        function removeProofOfInsurance(doc) {
            if (!doc || !vm.appraisalFirm.id) {
                return;
            }
            if (!$window.confirm($translate.instant('valueconnectApp.appraisalFirm.removeProofOfInsuranceConfirm'))) {
                return;
            }
            AppraisalFirm.deleteProofOfInsurance({ id: vm.appraisalFirm.id, fileId: doc.id }, function() {
                var idx = vm.appraisalFirm.proofOfInsurance.indexOf(doc);
                if (idx > -1) {
                    vm.appraisalFirm.proofOfInsurance.splice(idx, 1);
                }
            }, function() {
                vm.proofOfInsuranceError = 'UPLOAD_FAILED';
            });
        }

        vm.headOfficeDisplayLine1 = 'Office name: ' + vm.appraisalFirm.headOfficeOfficeName;
        vm.headOfficeDisplayLine2 = 'Office address: ' + vm.appraisalFirm.headOfficeAddress.displayStringLong;
        vm.headOfficeDisplayLine3 = 'Appraisal Firm Location ID: ' + vm.appraisalFirm.headOfficeId;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function save() {
            vm.isSaving = true;
            if (vm.appraisalFirm.independent) {
                vm.appraisalFirm.assistantId = null;
            }
            if (vm.appraisalFirm.id !== null) {
                AppraisalFirm.update(vm.appraisalFirm, onSaveSuccess, onSaveError);
            } else {
                AppraisalFirm.save(vm.appraisalFirm, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $scope.$emit('valueconnectApp:appraisalFirmUpdate', result);

            if(vm.isNew) {
                $state.go('appraisal-firm', null, { reload: true });
            }
            else {
                $state.go('.', {id: result.id}, {reload: true})
            }
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
